// extracted by mini-css-extract-plugin
export default {"hideProductsBar":"Header-module__hideProductsBar___fqvF7","hideCurrencyPicker":"Header-module__hideCurrencyPicker___MHjQI"};